export const CheckboxItem = ({ checked, onChange, children }) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      cursor: "pointer",
    }}
    onClick={onChange}
  >
    <div
      style={{
        minWidth: "18px",
        height: "18px",
        borderRadius: "50%",
        background: checked ? "rgb(41 33 79)" : "rgb(23 26 51)",
        flexShrink: 0,
        marginTop: "2px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: checked ? "none" : "1.5px solid #9b93b8",
        transition: "background 0.2s, border 0.2s",
        cursor: "pointer",
      }}
    >
      {checked && (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path
            d="M2 5l2.5 2.5L8 3"
            stroke="#fff"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
    <span
      style={{
        color: "#9b93b8",
        fontSize: "13px",
        lineHeight: "1.4",
        userSelect: "none",
      }}
    >
      {children}
    </span>
  </div>
);